import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStateService } from './auth-state.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authStateService = inject(AuthStateService);

    // Non-blocking: starts auth if needed and returns true immediately.
    // HomeComponent will wait for auth completion before loading data.
    return authStateService.ensureAuthenticated();
};
